import { Encoder, MGPFallible } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { Ordinal } from '../../jscaip/Ordinal';
import { RulesFailure } from '../../jscaip/RulesFailure';
import { MartianChessState } from './MartianChessState';
export class MartianChessMoveFailure {
    static START_COORD_OUT_OF_RANGE = () => $localize `Start coord cannot be out of range`;
    static END_COORD_OUT_OF_RANGE = () => $localize `End coord cannot be out of range`;
    static PAWN_MUST_MOVE_ONE_DIAGONAL_STEP = () => $localize `Pawns must move one step diagonally.`;
    static DRONE_MUST_DO_TWO_ORTHOGONAL_STEPS = () => $localize `Drones must move one or two steps in any direction.`;
}
export class MartianChessMove extends MoveCoordToCoord {
    calledTheClock;
    static encoder = Encoder.tuple([Coord.encoder, Coord.encoder, Encoder.identity()], (move) => [move.getStart(), move.getEnd(), move.calledTheClock], (f) => MartianChessMove.from(f[0], f[1], f[2]).get());
    static from(start, end, calledTheClock = false) {
        if (MartianChessState.isNotOnBoard(start)) {
            return MGPFallible.failure(MartianChessMoveFailure.START_COORD_OUT_OF_RANGE());
        }
        if (MartianChessState.isNotOnBoard(end)) {
            return MGPFallible.failure(MartianChessMoveFailure.END_COORD_OUT_OF_RANGE());
        }
        if (end.equals(start)) {
            return MGPFallible.failure(RulesFailure.MOVE_CANNOT_BE_STATIC());
        }
        const dir = Ordinal.factory.fromDelta(end.x - start.x, end.y - start.y);
        if (dir.isFailure()) {
            return MGPFallible.failure(dir.getReason());
        }
        return MGPFallible.success(new MartianChessMove(start, end, calledTheClock));
    }
    constructor(start, end, calledTheClock) {
        super(start, end);
        this.calledTheClock = calledTheClock;
    }
    toString() {
        const ending = this.calledTheClock ? ', CALL_THE_CLOCK' : '';
        return 'MartianChessMove((' + this.getStart().x + ', ' + this.getStart().y + ') -> (' +
            this.getEnd().x + ', ' + this.getEnd().y + ')' +
            ending + ')';
    }
    equals(other) {
        if (super.equals(other) === false) {
            return false;
        }
        else {
            return this.calledTheClock === other.calledTheClock;
        }
    }
    isValidForPawn() {
        const vector = this.getStart().getVectorToward(this.getEnd());
        return vector.isDiagonalOfLength(1);
    }
    isValidForDrone() {
        const distance = this.getStart().getLinearDistanceToward(this.getEnd());
        return distance <= 2;
    }
    isUndoneBy(moveOpt) {
        if (moveOpt.isAbsent()) {
            return false;
        }
        const move = moveOpt.get();
        return move.getEnd().equals(this.getStart()) && move.getStart().equals(this.getEnd());
    }
}
